module.exports = __webpack_public_path__ + "img/default-avatar.e591c6d8.png";